export default {
  currentClassAttendance: {
    time: '',
    date: '',
    subject: '',
    class: '',
    attendance: [],
  },
}
